<div cards>
  @for (player of ts.players; track $index) {
    <div player>
      <div name>{{ player.name }}</div>
      <div hand>
        @if (player.cards.length > 0) {
          <app-tacta-card [game]="player.game(0)" info="{{Utils.hex(player.cards[0])}}"></app-tacta-card>
          @if (player.cards.length > 1) {
            <app-tacta-card [game]="player.game(player.cards.length - 1)" info="{{Utils.hex(player.cards[player.cards.length - 1])}}"></app-tacta-card>
          }
        }
      </div>
    </div>
  }
</div>
<div board>
  @for (game of ts.games; track $index) {
    @if (ts.games.length > 1) {
      <app-tacta-card [game]="game" info="{{Utils.hex($index)}}"></app-tacta-card>
    } @else {
      <app-tacta-board [game]="game"></app-tacta-board>
    }
  }
</div>
